import React, { Component } from 'react'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/CloseOutlined'
import Chip from '@material-ui/core/Chip'
import Paper from '@material-ui/core/Paper'
import CircularProgress from '@material-ui/core/CircularProgress'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import FilterListIcon from '@material-ui/icons/FilterList'
import Popover from '@material-ui/core/Popover'
import ListSimple from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Link from '@material-ui/core/Link'
import Backdrop from '@material-ui/core/Backdrop'
import _ from 'lodash'

import { history } from '../../store'
import { BaseContext } from '../theme.context'
import Table from '../../Components/Table.component'
import List from '../../Components/SimpleListItem.component'
import TextField from '../../Components/TextField.component'
import { getPointsWithTags } from '../../Controllers/Points/points.selector'
import { GET_EXTRAS } from '../../Controllers/Extras/extras.actions'
import {
  POINTS_CREATE_CACHE,
  POINTS_SET_SELECTED_POINT_SUCCEEDED,
} from '../../Controllers/Points/points.actions'
import { FORM_SELECT_POINT } from '../Forms/forms.actions'

const cells = [{
  key: 'name',
  label: 'Nombre',
}, {
  key: 'address',
  label: 'Dirección',
}, {
  key: 'clasification',
  label: 'Clasificación',
}, {
  key: 'actions',
  label: 'Ver',
}]

const compareText = (text = '', search = '', isUnion) => {
  const newSearch = _.compact(search
    .split(',')
    .map(txt => txt.toLowerCase().replace(/ /g, '')))

  const newText = text.toLowerCase().replace(/ /g, '')
  const intersection = newSearch.filter(filter => newText.includes(filter))

  return isUnion
    ? Boolean(intersection.length)
    : intersection.length === newSearch.length
}

const ShowCard = props => {
  const { loading, classes, extrasOrTags, cardTitle } = props

  if (loading) {
    return (
      <CardContent className={classes.cardContent}>
        <Container className={classes.fetching}>
          <CircularProgress
            color='secondary'
          />
        </Container>
      </CardContent>
    )
  }

  if (extrasOrTags.length !== 0) {
    if (cardTitle === 'Extras') {
      return (
        <CardContent className={classes.cardContent}>
          <List
            data={extrasOrTags}
            keyTitle='label'
            keyValue='value'
          />
        </CardContent>
      )
    }
  
    if (cardTitle === 'Tags') {
      return (
        _.map(extrasOrTags, (item, i) => {
          return (
            <Chip
              key={i.toString()}
              className={classes.chip}
              size='small'
              label={item}
            />
          )
        })
      )
    }
  }

  return (
    <Container className={classes.noData}>
      <Typography
        className={classes.noDataText}
        variant='subtitle1'
      >
        Sin datos para mostrar
      </Typography>
    </Container>
  )
}

export class Points extends Component {
  static contextType = BaseContext

  state = {
    searchText: '',
    isUnion: true,
    menuFilteranchorEl: null,
    idPopover: null,
    anchorElPopover: null,
  }

  componentDidMount() {
    this.context.onChangeColor()
    this.context.onChangeleftButton(
      true,
      null,
      history.goBack,
      )
  }

  pointsWithActions(){
    const {
      searchText,
      isUnion,
      idPopover,
      anchorElPopover,
    } = this.state
    const {
      points,
      profile,
      getExtras,
      selectPoint,
      onFormSelectPoint,
      linksMenu,
      createCacheAndGoTo,
      loadingCache,
    } = this.props

    const pointsFiltered = (searchText.trim().length
      ? _.filter(points, x =>
        compareText(
          `${x.name} ${x.address} ${x.clasification} ${x.tags.join(',')}`,
          searchText,
          isUnion,
        ))
      : points)

    const openedPopover = Boolean(anchorElPopover)

    const openPopover = event =>
      this.setState({ anchorElPopover: event.currentTarget })

    const closePopover = () => this.setState({ anchorElPopover: null })

    return _.map(pointsFiltered, point => ({
      ...point,
      actions:
        <Grid
          container
          direction='row'
        >
          <ButtonGroup size="small" color='secondary'>
            <Button
              onClick={() => {
                selectPoint({ selected: point, cardTitle: 'Tags', showCard: true })
              }}
            >
              Tags
            </Button>
            <Button
              onClick={() => {
                getExtras({ source: 'Point', value: point._id, })
                selectPoint({ selected: point, cardTitle: 'Extras', showCard: true })
              }}
            >
              Extras
            </Button>
            <Button
              onClick={() => {
                onFormSelectPoint({ label: point.name, value: point._id })
                history.push('/dashboard/forms/new')
              }}
            >
              Formulario
            </Button>
            {linksMenu.data.length !== 0 &&
              (
                <Button
                  aria-describedby={idPopover}
                  onClick={openPopover}
                >
                  {linksMenu.title}
                </Button>
              )
            }
          </ButtonGroup>
          {linksMenu.data.length !== 0 &&
            (
              <Popover
                id={openedPopover ? 'simple-popover' : null}
                open={openedPopover}
                anchorEl={anchorElPopover}
                onClose={closePopover}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                {linksMenu.data.map(elem => (
                  <ListSimple
                    disablePadding
                    aria-label='secondary mailbox agreements'
                  >
                    <Link
                      color='secondary'
                      underline='none'
                      onClick={() => {
                        createCacheAndGoTo({
                          point,
                          profile,
                          link: elem.value,
                          title: elem.label,
                        })
                        closePopover()
                      }}
                    >
                      <ListItem button>
                        <ListItemText primary={elem.label} />
                      </ListItem>
                    </Link>
                  </ListSimple>
                ))}
              </Popover>
            )
          }
          <Backdrop
            open={loadingCache}
            style={{
              zIndex: 1000,
              color: '#fff',
              backgroundColor: 'rgba(0, 0, 0, 0.11)',
            }}
          >
            <CircularProgress color='secondary' />
          </Backdrop>
        </Grid>
    }))
  }

  render() {
    const {
      classes,
      loading,
      showCard,
      cardTitle,
      selectPoint,
      extrasOrTags,
    } = this.props
    const {
      isUnion,
      searchText,
      menuFilteranchorEl,
    } = this.state

    const onSelectFilter = isUnion => () => {
      this.setState({ isUnion, menuFilteranchorEl: null })
    }

    return (
      <Container className={classes.container}>
        <Grid container xs={12}>
          <Grid
            item
            xs={12}
          >
            <Paper className={classes.paper}>
              <Typography gutterBottom variant='subtitle1'>
                {'Buscar punto'}
              </Typography>
              <TextField
                id={'Point-AutoComplete'}
                inputRef={ref => { this.autocomplete = ref }}
                className={classes.searchInput}
                onChange={event => this.setState({ searchText: event.target.value })}
                placeholder='Filtrar por nombre, dirección, clasificación o tags...'
                InputProps={searchText !== ''
                  ?
                    {
                      endAdornment: <IconButton
                          aria-label="close"
                          size='small'
                          onClick={() => {
                            this.setState({ searchText: '' })
                            this.autocomplete.value = ''
                          }}
                        >
                          <CloseIcon />
                        </IconButton>,
                    }
                  : {}}
              />
            </Paper>
          </Grid>
        </Grid>
        <Grid container xs={12} className={classes.containerBody}>
          <Grid
            item
            xs={12}
            lg={!showCard ? 12 : 8}
            className={classes.tableContainer}
          >
            <Table
              headCells={cells}
              title='Mi cartera'
              className={classes.table}
              renderIconsHeader={() => (
                <div className={classes.contentSearch}>
                  <div>
                    <IconButton
                      aria-label='Tipo de filtro'
                      aria-controls='menu-filter'
                      aria-haspopup='true'
                      onClick={event =>
                        this.setState({ menuFilteranchorEl: event.currentTarget })}
                      color='inherit'
                    >
                      <FilterListIcon />
                    </IconButton>
                    <Menu
                      id='menu-filter'
                      anchorEl={menuFilteranchorEl}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      open={Boolean(menuFilteranchorEl)}
                      onClose={() => this.setState({ menuFilteranchorEl: null })}
                    >
                      <MenuItem
                        onClick={onSelectFilter(true)}
                        selected={isUnion}
                      >
                        {'Union'}
                      </MenuItem>
                      <MenuItem
                        onClick={onSelectFilter(false)}
                        selected={!isUnion}
                      >
                        {'Intersección'}
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              )}
              defaultOrderBy='name'
              defaultOrder='asc'
              rows={this.pointsWithActions()}
            />
          </Grid>
          {showCard
            &&
            <Grid
              item
              xs={12}
              lg={!showCard ? 12 : 4}
              className={classes.cardContainer}
            >
              <Card className={classes.card}>
                <CardHeader
                  title={cardTitle}
                  className={classes.cardTitle}
                  action={
                    <IconButton
                      aria-label="close"
                      onClick={() =>
                        selectPoint({
                          selected: {},
                          cardTitle: '',
                          showCard: false,
                        })
                      }
                    >
                      <CloseIcon />
                    </IconButton>
                  }
                />
                <ShowCard
                  cardTitle={cardTitle}
                  classes={classes}
                  loading={loading}
                  extrasOrTags={extrasOrTags}
                />
              </Card>
            </Grid>}
        </Grid>
      </Container>
    )
  }
}

const mapStateToProps = (state, props) => {
  const { points } = getPointsWithTags(state)
  const {
    Points: {
      selected,
      cardTitle,
      showCard,
      loading,
      loadingCache,
    },
    Extras: {
      data: extrasData,
    },
    Login: {
      profile,
    },
    Addons: {
      data: addons,
      addonsConfig,
      addonsConfigValues,
    },
  } = state

  const addonsConfigKeyedByAddonId = _.keyBy(addonsConfig, x => x.addon_id)
  const addonsConfigValuesByAddonConfigId = _.keyBy(addonsConfigValues, x => x.addon_config_id)

  const linksMenu = _.reduce(addons, (acum, addon) => {
    if (addon.name === 'show_convenios') {
      const addonConfig = addonsConfigKeyedByAddonId[addon._id]
      const addonConfigValue = addonsConfigValuesByAddonConfigId[addonConfig._id]

      if (addonConfig && addonConfigValue) {
        return {
          ...acum,
          title: addon.title,
          data: acum.data.concat(_.orderBy(
            _.map(addonConfigValue.value, value => ({
              ...value,
            })),
            'order', 'asc',
          ))
        }
      }

      return acum
    }

    return acum
  }, {
    title: '',
    data: [],
  })

  const extras = extrasData[selected._id]
    ? extrasData[selected._id]
    : []
  const tags = selected.tags
    ? selected.tags
    : []

  return {
    points,
    loading,
    showCard,
    cardTitle,
    extrasOrTags: cardTitle === 'Extras'
      ? extras
      : cardTitle === 'Tags'
        ? tags
        : [],
    profile,
    linksMenu,
    loadingCache,
  }
}

const mapDispatchToProps = dispatch => ({
  selectPoint: payload => dispatch(POINTS_SET_SELECTED_POINT_SUCCEEDED(payload)),
  onFormSelectPoint: payload => dispatch(FORM_SELECT_POINT(payload)),
  getExtras: payload => dispatch(GET_EXTRAS(payload)),
  createCacheAndGoTo: payload => dispatch(POINTS_CREATE_CACHE(payload)),
})

const useStyles = theme => ({
  container: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    boxSizing: 'border-box',
    padding: 25,
    margin: 16,
  },
  contentSearch: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  searchInput: {
    width: '100%',
  },
  closeButton: {
    cursor: 'pointer',
  },
  containerBody: {
    padding: 16,
  },
  table: {
    height: 'calc(100vh - 295px)',
    margin: 0,
  },
  tableContainer: {
    height: '80%',
  },
  cardContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      marginTop: 50,
      justifyContent: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 0,
      justifyContent: 'flex-end',
    },
  },
  card: {
    overflow: 'auto',
    margin: 0,
    width: '90%',
    height: 'calc(100vh - 295px)',
  },
  cardTitle: {
    top: 0,
    zIndex: 100,
    position: 'sticky',
    backgroundColor: 'white',
  },
  cardContent: {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  chip: {
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 10,
    color: 'rgba(0, 0, 0, 0.54)',
  },
  fetching: {
    display: 'flex',
    padding: 70,
    justifyContent: 'center',
    alignItems: 'center',
  },
  noData: {
    display: 'flex',
    height: 'calc(100vh - 495px)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noDataText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export default compose(
  withRouter,
  withStyles(useStyles),
  connect(mapStateToProps, mapDispatchToProps),
)(Points)
